const authConfig = {
    authority: 'https://auth.dev.mile.so',
    client_id: '257326495255560538@meraki',
    redirect_uri: 'https://yeti.staging.mile.so/admin/domains',
    response_type: 'id_token token',
    scope: 'openid profile urn:zitadel:iam:user:metadata email',
    post_logout_redirect_uri: 'https://yeti.staging.mile.so/login',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
};

export default authConfig;



// WEBPACK FOOTER //
// ./src/authConfig.js